import React from 'react';
import DefaultModal from 'components/Modal/DefaultModal';
import { Row, Col, Form, Input } from 'reactstrap';
import { useForm } from 'react-hook-form';
import ReactButton from 'components/Buttons/ReactButton';
import ContactService from '../service/index';
import { toast } from 'react-toastify';
import { FlexController } from 'components/FlexControllerInput';
import { AiOutlineUserAdd } from 'react-icons/ai';
import { normalizePhoneNumber } from 'utils/fuctions/internationalPhoneFormatter';
import { normalizeDDI } from 'utils/fuctions/internationalPhoneFormatter';
import { getDefaultCountry } from 'services/ServiceCOUNTRYS';

const CreateContactModal = ({ isModalOpen, onModalToggle, ...props }) => {
  const onSubmit = async (data) => {
    try {
      const { name, phone } = data;

      const phoneNumber = normalizePhoneNumber(
        data?.__number__ || phone?.number
      );
      const ddi = normalizeDDI(
        data?.__ddi__ || phone?.ddi || getDefaultCountry().dialCode
      );

      if (!phoneNumber || !ddi)
        toast.error('Preencha todos os campos obrigatórios');

      const usrLogin = localStorage.getItem('login');
      await ContactService.create({
        name,
        telephone: phoneNumber,
        ddi: ddi,
        usrLogin
      });

      onModalToggle(false);
      toast.success('Contato criado');
    } catch (error) {
      const msg =
        error.response && error.response.data && error.response.data.message;
      toast.error(msg || 'Erro ao criar contato');
    }
  };

  const { control, handleSubmit, errors, setValue, watch } = useForm();
  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Criar Contato"
      showCloseButton={false}
      modalContainerClasses="modal-lg"
      {...props}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
        <Row>
          <Col>
            <FlexController
              as={Input}
              textoDoLabel="Nome"
              name="name"
              value=""
              control={control}
              errors={errors}
              valueController={(fieldName, value) => {
                setValue(fieldName, value);
              }}
              rules={{ required: 'Campo obrigatório' }}
              disabled={false}
            />
          </Col>

          <Col>
            <FlexController
              type="phone"
              label="Telefone"
              name="phone"
              watch={watch}
              control={control}
              errors={errors}
              valueController={(fieldName, value) => {
                setValue(fieldName, value);
              }}
              rules={{ required: 'Campo obrigatório' }}
              disabled={false}
              renderCallIcon={false}
              renderMessageIcon={false}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '20px'
              }}
            >
              <ReactButton btnColor="confirmation" type="submit">
                <AiOutlineUserAdd size={16} /> Adicionar contato pessoal
              </ReactButton>
            </div>
          </Col>
        </Row>
      </Form>
    </DefaultModal>
  );
};

export default CreateContactModal;
